import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import enhancePostLinks from './service/postLinkEnhancer';
app.initializers.add('devconnect-link-cards', () => {
  extend(CommentPost.prototype, ['oncreate', 'onupdate'], function () {
    // Обработка выполняется после штатного render Flarum, поэтому не вмешивается в TextFormatter и редактор.
    if (app.forum.attribute('devconnectLinkCardsEnabled') !== false) {
      enhancePostLinks(this.$('.Post-body')[0], app.forum.attribute('devconnectLinkCardsPerPost'));
    }
  });
});